var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2374,
    height: 2131,
    viewBox: "0 0 2374 2131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1793.04 1710.18L1792.56 1712.15C1796.71 1707.95 1799.64 1704.48 1803.8 1700.29C1815.77 1689.64 1827.75 1678.99 1835.78 1667.39C1840.41 1661.21 1845.04 1655.03 1846.96 1647.16C1849.41 1645.66 1849.89 1643.7 1851.59 1640.98C1855.96 1631.61 1860.32 1622.25 1863.46 1613.62C1866.33 1601.81 1867.99 1590.73 1867.67 1579.18C1869.26 1521.17 1829.08 1463.42 1750.88 1420.41C1595.99 1336.84 1351.93 1341.12 1203.32 1433.26C1123.74 1481.71 1087.75 1543.88 1094.78 1605.04C1095.58 1614.62 1098.35 1624.68 1101.6 1632.77C1101.12 1634.74 1101.86 1635.96 1102.6 1637.19C1105.38 1647.25 1110.6 1655.82 1115.81 1664.39C1119.54 1670.51 1122.52 1675.4 1127.46 1680.79C1128.95 1683.23 1130.44 1685.68 1133.16 1687.39C1136.14 1692.28 1140.35 1696.43 1144.55 1700.58C1153.71 1710.11 1164.09 1718.89 1175.69 1726.93C1186.07 1735.71 1198.9 1743.01 1211.72 1750.3C1224.56 1757.59 1238.61 1764.13 1253.14 1768.71C1406.44 1833.11 1623.4 1820.17 1759.29 1737.44C1772.77 1729.24 1781.54 1718.86 1793.04 1710.18Z",
    fill: "#2D2D2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1961.85 1372.75L1961.37 1374.72C1965.52 1370.51 1968.45 1367.05 1972.6 1362.85C1984.58 1352.2 1996.56 1341.55 2004.59 1329.95C2009.22 1323.78 2013.85 1317.6 2015.77 1309.72C2018.22 1308.23 2018.69 1306.26 2020.4 1303.55C2024.76 1294.18 2029.13 1284.81 2032.27 1276.19C2035.14 1264.37 2036.8 1253.3 2036.47 1241.75C2038.07 1183.73 1997.89 1125.98 1919.69 1082.97C1764.79 999.409 1520.74 1003.68 1372.13 1095.83C1292.55 1144.27 1256.56 1206.45 1263.59 1267.61C1264.39 1277.19 1267.16 1287.25 1270.41 1295.34C1269.93 1297.31 1270.67 1298.53 1271.41 1299.75C1274.19 1309.81 1279.4 1318.38 1284.62 1326.95C1288.35 1333.07 1291.33 1337.97 1296.27 1343.35C1297.76 1345.8 1299.25 1348.25 1301.97 1349.95C1304.95 1354.85 1309.15 1358.99 1313.36 1363.15C1322.52 1372.67 1332.9 1381.46 1344.5 1389.49C1354.88 1398.28 1367.71 1405.57 1380.53 1412.86C1393.37 1420.15 1407.42 1426.7 1421.95 1431.27C1575.25 1495.67 1792.21 1482.73 1928.1 1400.01C1941.57 1391.81 1950.35 1381.43 1961.85 1372.75Z",
    fill: "#2D2D2D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M907.644 1482.31L907.164 1484.28C911.313 1480.08 914.243 1476.62 918.396 1472.42C930.369 1461.77 942.35 1451.12 950.385 1439.52C955.013 1433.34 959.641 1427.17 961.564 1419.29C964.015 1417.8 964.487 1415.83 966.192 1413.11C970.558 1403.75 974.924 1394.38 978.06 1385.75C980.934 1373.94 982.59 1362.86 982.268 1351.31C983.863 1293.3 943.68 1235.55 865.483 1192.54C710.587 1108.97 466.529 1113.25 317.919 1205.4C238.339 1253.84 202.356 1316.01 209.384 1377.17C210.186 1386.75 212.952 1396.81 216.198 1404.9C215.718 1406.88 216.46 1408.09 217.206 1409.32C219.98 1419.38 225.197 1427.95 230.414 1436.52C234.139 1442.64 237.118 1447.53 242.066 1452.92C243.553 1455.36 245.045 1457.81 247.763 1459.52C250.742 1464.41 254.947 1468.56 259.156 1472.72C268.311 1482.24 278.689 1491.03 290.288 1499.06C300.673 1507.84 313.502 1515.14 326.326 1522.43C339.162 1529.72 353.212 1536.26 367.746 1540.84C521.045 1605.24 738.004 1592.3 873.895 1509.58C887.367 1501.37 896.143 1490.99 907.644 1482.31Z",
    fill: "#2D2D2D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2259.37 696.138V1567.39L2199.26 1600.49L2195.02 1594.93L2199.26 1597.31V729.24L2259.37 696.138Z",
    fill: "#838983",
    stroke: "black",
    strokeWidth: 12.504,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2259.37 572.986V696.138L2199.26 729.24V1597.31L2195.02 1594.93L1273.98 366.963V7.60815L2259.37 572.986Z",
    fill: "#706E6E",
    stroke: "black",
    strokeWidth: 12.504,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2199.26 602.921V1597.31L2195.01 1594.93L1213.86 1031.66V37.27L1217.04 39.119L1273.98 71.692L2199.26 602.921Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 12.504,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1274.02 7.54907L1213.78 40.5751L2199.21 606.039L2259.46 573.013L1274.02 7.54907Z",
    fill: "#B6E656",
    stroke: "black",
    strokeWidth: 14.0963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1213.78 40.5752L2199.21 606.039V733.771L1213.78 168.307V40.5752Z",
    fill: "#B6E656",
    stroke: "black",
    strokeWidth: 14.0963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1255.14 420.031L1706.5 679.028V1000.05L1255.14 741.056V420.031Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 12.2838,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1255.14 797.828L1706.5 1056.83V1278.68L1255.14 1019.68V797.828Z",
    fill: "#B6E656",
    stroke: "black",
    strokeWidth: 12.2838,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1750.68 698.656L2113.89 907.077V1228.1L1750.68 1019.68V698.656Z",
    fill: "#B6E656",
    stroke: "black",
    strokeWidth: 12.2838,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1750.68 1087.84L2113.89 1296.26V1513.74L1750.68 1305.32V1087.84Z",
    fill: "#FEFFFB",
    stroke: "black",
    strokeWidth: 12.2838,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2085.14 709.411V837.155L1889.09 724.634L1264.35 365.957V238.441L1889.09 596.89L2085.14 709.411Z",
    fill: "#FFF3FF",
    stroke: "black",
    strokeWidth: 14.0963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2259.37 572.986V696.138L2199.26 729.24V606.089L2259.37 572.986Z",
    fill: "#B6E656",
    stroke: "black",
    strokeWidth: 14.0963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2085.14 709.411V837.155L1889.09 724.634V596.89L2085.14 709.411Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 12.2838,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1301.7 692.532L1431.18 642.178L1498.46 762.669L1663.17 702.424",
    stroke: "white",
    strokeWidth: 14.0963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1317.97 722.386C1325.89 716.584 1323.55 699.906 1312.73 685.137C1301.91 670.367 1286.72 663.098 1278.8 668.9C1270.88 674.703 1273.22 691.38 1284.04 706.15C1294.86 720.92 1310.05 728.189 1317.97 722.386Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 14.0963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1443.49 668.93C1451.41 663.128 1449.07 646.45 1438.25 631.681C1427.43 616.911 1412.24 609.642 1404.32 615.444C1396.4 621.247 1398.74 637.924 1409.56 652.694C1420.38 667.464 1435.57 674.733 1443.49 668.93Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 14.0963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1524.78 805.42C1532.7 799.617 1530.36 782.94 1519.54 768.17C1508.72 753.401 1493.53 746.131 1485.61 751.934C1477.68 757.737 1480.03 774.414 1490.85 789.184C1501.67 803.954 1516.86 811.223 1524.78 805.42Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 14.0963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1682.86 729.17C1690.78 723.368 1688.44 706.69 1677.62 691.921C1666.8 677.151 1651.61 669.882 1643.69 675.684C1635.76 681.487 1638.11 698.164 1648.93 712.934C1659.74 727.704 1674.94 734.973 1682.86 729.17Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 14.0963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1287.48 482.374L1423.81 562.888",
    stroke: "white",
    strokeWidth: 14.0963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1287.48 522.631L1379.25 576.825",
    stroke: "white",
    strokeWidth: 14.0963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1561.77 853.569L1653.54 907.763",
    stroke: "white",
    strokeWidth: 14.0963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1561.77 817.311L1653.54 871.506",
    stroke: "white",
    strokeWidth: 14.0963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1301.7 315.492L1736.62 572.335",
    stroke: "black",
    strokeWidth: 14.0963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1800.79 894.333V999.993L1846.89 1028.95V921.191L1800.79 894.333Z",
    fill: "#FFF3FF",
    stroke: "black",
    strokeWidth: 14.0963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1872.02 899.453V1038.34L1918.12 1067.3V926.312L1872.02 899.453Z",
    fill: "#FFF3FF",
    stroke: "black",
    strokeWidth: 14.0963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1943.24 880.666V1076.69L1989.34 1105.65V907.524L1943.24 880.666Z",
    fill: "#FFF3FF",
    stroke: "black",
    strokeWidth: 14.0963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M2014.47 960.419V1115.04L2060.57 1144V987.277L2014.47 960.419Z",
    fill: "#FFF3FF",
    stroke: "black",
    strokeWidth: 14.0963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1782.81 1268.96L1841.37 1283.86L1889.09 1306.22L1902.05 1323.26C1902.05 1323.26 1934.84 1334.62 1937.61 1331.07C1940.38 1327.52 1962.39 1331.53 1966.29 1328.99C1970.19 1326.45 2005.33 1317.93 2005.33 1317.93L2037.52 1331.75L2064.95 1326.45L2085.14 1315.8",
    fill: "#FEFFFB"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1782.81 1268.96L1841.37 1283.86L1889.09 1306.22L1902.05 1323.26C1902.05 1323.26 1934.84 1334.62 1937.61 1331.07C1940.38 1327.52 1962.39 1331.53 1966.29 1328.99C1970.19 1326.45 2005.33 1317.93 2005.33 1317.93L2037.52 1331.75L2064.95 1326.45L2085.14 1315.8",
    stroke: "black",
    strokeWidth: 12.2838,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1287.48 983.378H1333.36L1366.06 1011.24L1428.57 993.159L1480.82 1038.25L1542.47 1022.36L1607.66 1028.95L1625.81 1067.3L1674.74 1062.64",
    stroke: "black",
    strokeWidth: 12.2838,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1314.02 172.492C1321.94 166.689 1319.6 150.012 1308.78 135.242C1297.96 120.472 1282.77 113.203 1274.85 119.006C1266.92 124.809 1269.27 141.486 1280.09 156.256C1290.9 171.025 1306.1 178.295 1314.02 172.492Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 14.0963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1398.92 223.955C1406.84 218.153 1404.49 201.475 1393.68 186.705C1382.86 171.936 1367.67 164.667 1359.74 170.469C1351.82 176.272 1354.17 192.949 1364.99 207.719C1375.8 222.489 1390.99 229.758 1398.92 223.955Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 14.0963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1483.82 275.417C1491.74 269.614 1489.39 252.937 1478.57 238.167C1467.76 223.397 1452.57 216.128 1444.64 221.931C1436.72 227.734 1439.07 244.411 1449.88 259.181C1460.7 273.95 1475.89 281.22 1483.82 275.417Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 14.0963,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M2192.17 721.598V610.123L1220.82 52.748V62.291L2181.77 613.718C2183.97 614.985 2185.32 617.313 2185.32 619.834V717.667L2192.17 721.598Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M2202.61 588.723C2200.45 589.9 2197.83 589.874 2195.71 588.658L1234.64 37.1802L1228.18 40.7232L2199.3 597.955L2245.06 572.87L2238.44 569.081L2202.61 588.723Z",
    fill: "#B6E656"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M2207.88 716.464V620.338C2207.88 617.765 2209.29 615.398 2211.54 614.157L2252.41 591.761V584.908L2206.25 610.213V717.356L2207.88 716.464Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M2210.14 1587.36V740.554C2210.14 738.278 2211.37 736.17 2213.38 735.084L2253.13 713.192V706.714L2205.52 732.937V1589.9L2210.14 1587.36Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1055.74 7.54907L6.54297 618.904V1595.72L66.788 1628.75L1055.74 366.832V7.54907Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 12.2838,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1115.99 37.395L66.7891 648.75V1625.57L1115.99 1014.21V37.395Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 12.2838,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1055.74 7.54907L1115.99 40.5751L66.788 651.93L6.54297 618.904L1055.74 7.54907Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 12.2838,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9597 659.285L1109.84 63.2611V48.0801L72.9297 652.277V1614.89L86.9597 1606.71V659.285Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9274 632.778L25.9544 614.701L19.0234 618.735L66.6984 644.881L1103.5 40.7361L1091.84 34.3481L64.9654 632.7C63.1034 633.773 60.8144 633.812 58.9274 632.778Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M588.06 871.506L122.414 1142.83",
    stroke: "white",
    strokeWidth: 12.2838,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M588.06 931.64L122.414 1202.97",
    stroke: "white",
    strokeWidth: 12.2838,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M588.06 991.774L122.414 1263.1",
    stroke: "white",
    strokeWidth: 12.2838,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M588.06 1051.91L122.414 1323.23",
    stroke: "white",
    strokeWidth: 12.2838,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M588.06 1112.04L122.414 1383.37",
    stroke: "white",
    strokeWidth: 12.2838,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M588.06 1172.18L122.414 1443.5",
    stroke: "white",
    strokeWidth: 12.2838,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M1015.03 666.505L689.172 856.356V1132.4L1015.03 942.551V666.505Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 12.2838,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M1015.03 197.322L689.172 387.173V818.149L1015.03 628.297V197.322Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 12.2838,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M733.93 880.666L934.639 762.669",
    stroke: "black",
    strokeWidth: 12.2838,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M733.93 925.399L977.495 781.307",
    stroke: "black",
    strokeWidth: 12.2838,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M733.93 970.131L977.495 826.039",
    stroke: "black",
    strokeWidth: 12.2838,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M733.93 1014.86L977.495 870.772",
    stroke: "black",
    strokeWidth: 12.2838,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M733.93 1059.6L977.495 915.505",
    stroke: "black",
    strokeWidth: 12.2838,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M867.6 507.812C867.6 507.812 817.416 600.67 782.792 659.39C804.87 670.933 834.985 668.421 867.857 649.354C936.1 610.204 991.05 514.846 990.805 436.545C990.548 358.244 935.096 326.63 867.098 366.025C833.479 385.606 802.861 418.973 780.539 457.119L867.6 507.812Z",
    fill: "#B6E656",
    stroke: "black",
    strokeWidth: 12.4148,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M713.492 585.779C713.749 626.179 728.549 654.289 752.134 666.335C786.758 607.616 836.942 514.757 836.942 514.757L749.88 464.064C727.288 502.712 713.235 546.384 713.492 585.779Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 10.8185,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M519.644 639.856L444.941 683.378V821.916L519.644 778.394V639.856Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 12.2838,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M197.117 832.155L122.414 875.676V1014.21L197.117 970.693V832.155Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 12.2838,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M411.387 569.635L336.684 613.156V885.824L411.387 842.302V569.635Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 12.2838,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M303.133 692.373L228.43 735.894V949.732L303.133 906.211V692.373Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 12.2838,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M1078.57 1004.48L1782.52 1414.59V1876.51L1728.49 1906.13L1078.57 1326.71V1004.48Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 17.9341,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.54 1031.25L1728.49 1441.36V1903.28L1024.54 1493.16V1031.25Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 17.9341,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M1078.57 1004.48L1024.54 1034.1L1728.49 1444.21L1782.52 1414.59L1078.57 1004.48Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 17.9341,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M1719.53 1887.68V1446.5L1033.51 1046.84V1065.8L1698.86 1453.44C1701.61 1455.05 1703.32 1458 1703.32 1461.19V1878.23L1719.53 1887.68Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M1723.98 1417.93C1721.22 1419.44 1717.87 1419.4 1715.16 1417.81L1050.06 1030.34L1042.75 1034.33L1728.62 1433.91L1764.3 1414.36L1747.93 1404.81L1723.98 1417.93Z",
    fill: "black"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M1184.05 1378.92C1184.05 1378.92 1235.16 1473.48 1270.42 1533.27C1247.93 1545.02 1217.26 1542.46 1183.79 1523.05C1114.29 1483.18 1058.33 1386.08 1058.58 1306.35C1058.84 1226.62 1115.31 1194.43 1184.56 1234.54C1218.8 1254.48 1249.98 1288.46 1272.71 1327.3L1184.05 1378.92Z",
    fill: "#B6E656",
    stroke: "black",
    strokeWidth: 19.1654,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M1340.99 1458.31C1340.73 1499.45 1325.66 1528.07 1301.64 1540.34C1266.38 1480.55 1215.27 1385.99 1215.27 1385.99L1303.93 1334.38C1326.94 1373.73 1341.25 1418.2 1340.99 1458.31Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 17.2019,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M1388.45 1469.42L1455.44 1508.45V1632.7L1388.45 1593.67V1469.42Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 19.1654,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M1485.54 1480.26L1552.53 1519.29V1690.02L1485.54 1650.99V1480.26Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 19.1654,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M1582.62 1453.28L1649.62 1492.31V1747.34L1582.62 1708.31V1453.28Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 19.1654,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1237.5 2031.14L1237.02 2033.11C1241.17 2028.91 1244.1 2025.45 1248.25 2021.25C1260.23 2010.6 1272.21 1999.95 1280.24 1988.35C1284.87 1982.17 1289.5 1976 1291.42 1968.12C1293.87 1966.63 1294.34 1964.66 1296.05 1961.94C1300.41 1952.58 1304.78 1943.21 1307.92 1934.58C1310.79 1922.77 1312.45 1911.69 1312.12 1900.14C1313.72 1842.13 1273.54 1784.38 1195.34 1741.37C1040.44 1657.8 796.385 1662.08 647.775 1754.23C568.195 1802.67 532.212 1864.84 539.24 1926C540.042 1935.58 542.808 1945.64 546.054 1953.74C545.575 1955.71 546.316 1956.92 547.062 1958.15C549.836 1968.21 555.053 1976.78 560.27 1985.35C563.995 1991.47 566.974 1996.36 571.922 2001.75C573.409 2004.19 574.901 2006.64 577.619 2008.35C580.598 2013.24 584.803 2017.39 589.012 2021.55C598.167 2031.07 608.545 2039.86 620.144 2047.89C630.529 2056.67 643.358 2063.97 656.182 2071.26C669.018 2078.55 683.068 2085.09 697.602 2089.67C850.901 2154.07 1067.86 2141.13 1203.75 2058.41C1217.22 2050.2 1226 2039.82 1237.5 2031.14Z",
    fill: "#2D2D2D"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.33 1792.59C1086.33 1792.82 1086.33 1793.28 1086.33 1793.28L1083.34 1815.76L820.958 1793.74L807.653 1792.59C810.632 1792.59 818.897 1805.21 822.57 1858.19C746.651 1860.71 669.119 1845.11 611.096 1811.4C566.602 1785.71 539.993 1753.6 531.504 1720.1C531.504 1719.42 531.28 1718.96 531.28 1718.5L529.219 1702.22C531.044 1684.1 534.259 1666.21 540.228 1650.61C540.228 1650.39 540.452 1650.39 540.452 1650.39C546.869 1633.41 556.736 1619.19 571.418 1610.71C571.418 1610.71 571.418 1610.48 571.642 1610.71C680.364 1547.4 894.581 1615.29 1003.76 1678.6C1024.17 1690.29 1040.91 1703.37 1053.75 1717.36V1717.58C1075.31 1741.22 1086.1 1766.9 1086.33 1792.59Z",
    fill: "#B6E656",
    stroke: "black",
    strokeWidth: 14.8725,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M1083.34 1720.39V1815.79L818.281 1792.52V1697.22L1083.34 1720.39Z",
    fill: "#B6E656",
    stroke: "black",
    strokeWidth: 14.8725,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M1121.42 1756.12V1847.64C1113.39 1880.66 1087.48 1912.78 1043.21 1938C992.518 1967.58 927.148 1983.19 860.636 1984.79C855.82 1905.66 849.862 1823.79 845.73 1823.79V1732.27C847.332 1753.81 859.259 1869.88 860.636 1893.28C927.148 1891.68 992.517 1876.08 1043.21 1846.49C1046.2 1844.89 1049.17 1843.05 1051.93 1841.21C1090.91 1816.9 1113.85 1786.85 1121.42 1756.12Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 17.3044,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M1051.93 1841.21C1049.17 1843.05 1046.19 1844.89 1043.2 1846.49C992.518 1876.08 927.148 1891.68 860.636 1893.28C859.258 1869.88 857.657 1846.25 856.055 1824.7L1051.93 1841.21Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 17.3044,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M1121.42 1755.43V1756.12C1113.85 1786.85 1090.91 1816.9 1051.93 1841.21C1049.18 1843.05 1046.2 1844.89 1043.21 1846.49C992.519 1876.08 927.149 1891.68 860.637 1893.28C859.259 1869.88 857.658 1846.25 856.056 1824.7C852.383 1772.86 848.709 1732.27 845.73 1732.27L1121.42 1755.43Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 17.3044,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.34 1697.17C1086.34 1697.4 1086.34 1697.86 1086.34 1697.86L1083.35 1720.34L1053.76 1717.58V1717.36L818.206 1694.65L820.961 1793.74L822.574 1858.19C746.655 1860.71 669.123 1845.11 611.1 1811.4C566.606 1785.71 539.997 1753.6 531.508 1720.1C531.508 1719.42 531.284 1718.96 531.284 1718.5L529.223 1702.22L528.764 1697.4V1697.17C528.529 1681.58 532.426 1665.75 540.232 1650.61C540.232 1650.39 540.456 1650.39 540.456 1650.39C547.343 1636.63 557.658 1623.1 571.422 1610.71C571.422 1610.71 571.422 1610.47 571.646 1610.71C582.196 1600.84 594.817 1591.67 609.499 1583.18C718.209 1519.88 894.585 1519.88 1003.77 1583.18C1058.35 1614.37 1085.86 1656.12 1086.34 1697.17Z",
    fill: "#B6E656",
    stroke: "black",
    strokeWidth: 14.6622,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M818.987 1687.34L1077 1712.4L1079.07 1696.93C1078.86 1683.09 1075.18 1669.14 1068.19 1655.59C1068.38 1657.87 1068.48 1660.17 1068.51 1662.45L1065.46 1686.66C1064.93 1690.58 1061.41 1693.41 1057.49 1693L800.678 1668.05L804.742 1823.35C804.854 1827.37 801.685 1830.73 797.664 1830.87C718.766 1833.46 641.424 1816.63 584.812 1784.56C593.726 1791.85 603.74 1798.72 614.76 1805.08C667.575 1835.77 740.223 1852.41 815.045 1851.08L810.958 1694.83C810.902 1692.73 811.753 1690.71 813.287 1689.27C814.821 1687.85 816.893 1687.13 818.987 1687.34Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M822.57 1953.6C746.651 1956.12 669.119 1940.53 611.096 1906.81C566.602 1881.13 539.993 1849.01 531.504 1815.52C531.504 1814.84 531.28 1814.38 531.28 1813.92L528.76 1792.82V1792.59C528.525 1772.87 525.77 1737.31 529.219 1702.22L531.28 1718.51C531.28 1718.96 531.504 1719.42 531.504 1720.11C539.993 1753.6 566.602 1785.71 611.096 1811.4C669.119 1845.11 746.651 1860.71 822.57 1858.19C823.937 1879.05 821.193 1931.35 822.57 1953.6Z",
    fill: "#B6E656",
    stroke: "black",
    strokeWidth: 14.8725,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M815.438 1865.78C812.089 1865.83 808.73 1865.83 805.37 1865.81L805.168 1878.93C804.832 1897.03 804.496 1915.74 805.168 1926.59C805.291 1928.6 804.597 1930.57 803.242 1932.06C801.898 1933.54 799.994 1934.42 797.99 1934.49C739.452 1936.4 681.754 1927.65 632.746 1909.89C683.4 1934.43 748.265 1947.47 814.845 1946.35C814.576 1934.98 814.867 1919.76 815.136 1904.95C815.404 1890.78 815.673 1876.21 815.438 1865.78Z",
    fill: "#0F3F23"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M875.507 1863.74C874.13 1840.38 872.528 1816.8 870.927 1795.3C869.527 1775.47 868.127 1757.52 866.772 1742.72L857.32 1741.92C859.515 1755.91 861.598 1780.58 864.689 1824.1C866.1 1843.07 867.511 1863.7 868.766 1884.35C929.555 1881.8 986.592 1867.37 1031.2 1843.31C988.093 1860.61 937.361 1870.6 884.355 1871.88C879.662 1872.01 875.776 1868.39 875.507 1863.74Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M936.948 1189.63V1366.26C936.948 1381.35 906.238 1406.24 885.316 1410.48C891.665 1406.24 896.165 1398.83 896.165 1389.82V1213.46C896.165 1194.92 886.635 1177.71 870.485 1168.44L582.895 999.484C563.822 988.364 540.25 999.484 535.75 1019.88L534.961 1016.7C534.961 992.334 602.485 963.201 623.406 975.653L911.268 1144.86C927.159 1154.13 936.948 1171.35 936.948 1189.63Z",
    fill: "#B6E656",
    stroke: "black",
    strokeWidth: 13.5196,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M896.162 1213.46V1389.82C896.162 1398.83 891.662 1406.24 885.313 1410.48L885.041 1410.74C880.011 1411.55 875.253 1411.27 872.072 1409.42L773.295 1313.3C758.722 1304.82 740.451 1307.74 729.602 1320.18L718.74 1332.36L649.884 1409.43L609.372 1433.26L649.884 1240.99L599.571 1211.34C584.74 1202.6 575.74 1186.71 575.74 1169.77L535.746 1020.14C535.746 1019.88 535.746 1019.88 535.746 1019.88C540.246 999.484 563.818 988.364 582.891 999.484L870.481 1168.44C886.632 1177.71 896.162 1194.92 896.162 1213.46Z",
    fill: "#B6E656",
    stroke: "black",
    strokeWidth: 13.5196,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M896.163 1213.46V1389.82C896.163 1398.83 891.663 1406.24 885.314 1410.48L885.042 1410.74C877.633 1415.51 867.831 1416.58 859.09 1411.27L732.512 1336.86C728.012 1334.22 723.241 1332.89 718.741 1332.36C707.621 1331.04 696.5 1335.01 688.819 1343.75L609.373 1433.26V1264.56L558.788 1234.91C543.957 1226.17 534.957 1210.54 534.957 1193.33V1026.76C534.957 1024.38 535.216 1022.26 535.746 1020.13C535.746 1019.88 535.746 1019.88 535.746 1019.88C540.246 999.483 563.818 988.363 582.891 999.483L870.481 1168.44C886.633 1177.71 896.163 1194.92 896.163 1213.46Z",
    fill: "#B6E656",
    stroke: "black",
    strokeWidth: 13.5196,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M595.418 1064.24L689.575 1121.7",
    stroke: "black",
    strokeWidth: 13.5196,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M595.418 1111.35L849.473 1263.04",
    stroke: "black",
    strokeWidth: 13.5196,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M595.418 1158.47L849.473 1310.16",
    stroke: "black",
    strokeWidth: 13.5196,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M595.418 1205.58L849.473 1357.27",
    stroke: "black",
    strokeWidth: 13.5196,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M878.731 1406.28C880.58 1405.48 882.313 1404.38 883.839 1403C887.511 1399.65 889.528 1395.02 889.528 1389.94V1213.36C889.528 1197.36 880.968 1182.39 867.171 1174.29L579.387 1005.21C571.667 1000.66 563.495 1001.01 556.836 1004.04C558.646 1004.75 560.405 1005.6 562.099 1006.6L849.883 1175.68C867.792 1186.19 878.912 1205.64 878.912 1226.4V1402.98C878.912 1404.1 878.848 1405.18 878.731 1406.28Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M890.253 1163.33L602.598 994.338C596.029 990.498 589.06 990.135 583.008 991.933C584.12 992.45 585.219 993.019 586.292 993.64L873.908 1162.6C891.778 1172.87 902.924 1192.37 902.924 1213.46V1389.82C902.924 1391.93 902.717 1394 902.329 1396.02C902.51 1395.91 902.678 1395.81 902.859 1395.69C903.338 1394.99 903.945 1394.37 904.695 1393.88C909.673 1390.56 912.531 1385.08 912.531 1378.84V1202.48C912.532 1186.22 903.998 1171.22 890.253 1163.33Z",
    fill: "#064B5B"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M2366.79 1619.37V1796C2366.79 1811.09 2336.08 1835.98 2315.16 1840.22C2321.51 1835.98 2326.01 1828.57 2326.01 1819.56V1643.2C2326.01 1624.66 2316.48 1607.44 2300.33 1598.17L2012.74 1429.22C1993.67 1418.1 1970.09 1429.22 1965.59 1449.61L1964.8 1446.43C1964.8 1422.07 2032.33 1392.94 2053.25 1405.39L2341.11 1574.6C2357 1583.87 2366.79 1601.08 2366.79 1619.37Z",
    fill: "#B6E656",
    stroke: "black",
    strokeWidth: 13.5196,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M2326.01 1643.2V1819.56C2326.01 1828.57 2321.51 1835.98 2315.16 1840.22L2314.89 1840.48C2309.86 1841.28 2305.1 1841.01 2301.92 1839.16L2203.14 1743.04C2188.57 1734.55 2170.3 1737.48 2159.45 1749.92L2148.59 1762.1L2079.73 1839.16L2039.22 1862.99L2079.73 1670.73L2029.42 1641.08C2014.59 1632.34 2005.59 1616.45 2005.59 1599.51L1965.59 1449.87C1965.59 1449.61 1965.59 1449.61 1965.59 1449.61C1970.09 1429.22 1993.67 1418.1 2012.74 1429.22L2300.33 1598.17C2316.48 1607.44 2326.01 1624.66 2326.01 1643.2Z",
    fill: "#B6E656",
    stroke: "black",
    strokeWidth: 13.5196,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M2326.01 1643.2V1819.56C2326.01 1828.57 2321.51 1835.98 2315.16 1840.22L2314.89 1840.48C2307.48 1845.25 2297.68 1846.31 2288.94 1841.01L2162.36 1766.6C2157.86 1763.96 2153.09 1762.63 2148.59 1762.1C2137.47 1760.78 2126.35 1764.75 2118.67 1773.49L2039.22 1862.99V1694.3L1988.64 1664.65C1973.8 1655.91 1964.8 1640.28 1964.8 1623.07V1456.49C1964.8 1454.11 1965.06 1451.99 1965.59 1449.87C1965.59 1449.61 1965.59 1449.61 1965.59 1449.61C1970.09 1429.22 1993.67 1418.1 2012.74 1429.22L2300.33 1598.17C2316.48 1607.44 2326.01 1624.66 2326.01 1643.2Z",
    fill: "#B6E656",
    stroke: "black",
    strokeWidth: 12.2838,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M2308.58 1836.02C2310.43 1835.22 2312.16 1834.12 2313.69 1832.74C2317.36 1829.39 2319.38 1824.76 2319.38 1819.68V1643.09C2319.38 1627.1 2310.82 1612.13 2297.02 1604.03L2009.23 1434.95C2001.51 1430.4 1993.34 1430.75 1986.68 1433.77C1988.49 1434.48 1990.25 1435.34 1991.95 1436.33L2279.73 1605.41C2297.64 1615.93 2308.76 1635.37 2308.76 1656.14V1832.72C2308.76 1833.83 2308.69 1834.92 2308.58 1836.02Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M2320.1 1593.07L2032.45 1424.08C2025.88 1420.24 2018.91 1419.87 2012.86 1421.67C2013.97 1422.19 2015.07 1422.76 2016.14 1423.38L2303.76 1592.34C2321.63 1602.61 2332.77 1622.11 2332.77 1643.2V1819.56C2332.77 1821.67 2332.56 1823.74 2332.18 1825.75C2332.36 1825.65 2332.53 1825.55 2332.71 1825.43C2333.19 1824.73 2333.79 1824.11 2334.54 1823.62C2339.52 1820.3 2342.38 1814.81 2342.38 1808.58V1632.22C2342.38 1615.95 2333.85 1600.95 2320.1 1593.07Z",
    fill: "#B6E656"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M2074.76 1607.75C2082.53 1601.69 2080.76 1586.44 2070.81 1573.69C2060.86 1560.95 2046.49 1555.53 2038.72 1561.6C2030.95 1567.66 2032.72 1582.91 2042.67 1595.66C2052.62 1608.41 2066.99 1613.82 2074.76 1607.75Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 12.2838,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M2150.44 1644.43C2158.21 1638.36 2156.44 1623.11 2146.49 1610.37C2136.54 1597.62 2122.17 1592.21 2114.4 1598.27C2106.63 1604.34 2108.4 1619.59 2118.35 1632.34C2128.31 1645.08 2142.67 1650.5 2150.44 1644.43Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 12.2838,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M2226.12 1681.08C2233.89 1675.01 2232.13 1659.76 2222.17 1647.02C2212.22 1634.27 2197.86 1628.86 2190.09 1634.93C2182.32 1640.99 2184.09 1656.24 2194.04 1668.99C2203.99 1681.73 2218.35 1687.15 2226.12 1681.08Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 12.2838,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.7602dd223fa10e07caf50358b625485b.svg";
export { ForwardRef as ReactComponent };